export default __webpack_public_path__ + "static/media/first_thumb.a991300d.png";